module.exports = __webpack_public_path__ + "020.bdbe4b47.png";